import { Type } from '@angular/core';

export class FooterItem {
  constructor(public component: Type<any>, public data: any) {}
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/footer/footer-item.ts